@if ({
  product: product$ | async,
  }; as content) {
  @if (!content.product?.discontinued && content.product?.allowProductConfiguration) {
    <div class="container-modify-motors">
      <button class="btn btn-secondary w-100" (click)="openNewTab()">
        <span class="material-symbols-outlined m-r-4"> settings </span>
        {{ 'modifyMotors.label' | cxTranslate }}
      </button>
    </div>
  }
}
